import { useTheme } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { atlasLensNestedDialogRootSx } from '../Form/atlasLensStyles';
import { useOnboardingOverlayContainer } from './OnboardingOverlayContainerContext';

export type OnboardingNestedDialogProps = {
  nested: boolean;
  container?: HTMLElement;
  disablePortal: boolean;
  sx?: SxProps<Theme>;
  rootZIndex: number;
};

/** Mount onboarding child dialogs over the wizard paper, not the viewport. */
export function useOnboardingNestedDialog(
  modalZIndex?: number,
): OnboardingNestedDialogProps {
  const theme = useTheme();
  const overlayContainer = useOnboardingOverlayContainer();
  const nested = overlayContainer != null;
  const rootZIndex = modalZIndex ?? theme.zIndex.modal + 2;

  return {
    nested,
    container: nested ? overlayContainer : undefined,
    disablePortal: nested,
    sx: nested ? atlasLensNestedDialogRootSx(rootZIndex) : undefined,
    rootZIndex,
  };
}
